import apiSlice from './apiSlice';

const apiSliceWithTag = apiSlice.enhanceEndpoints({ addTagTypes: ['Geo'] });

const apiGeoSlice = apiSliceWithTag.injectEndpoints({
  endpoints: (builder) => ({
    getGeoNamesBySearch: builder.query({
      query: (substr) => `/geo/search/${substr}/`,
      providesTags: ['Geo'],
    }),
    getGeoNameByGeonameIdAndLang: builder.query({
      query: ({ geonameId, lang }) => `/geo/entities/${geonameId}/displayname/${lang}/`,
      providesTags: ['Geo'],
    }),
    getGeoCityInfoById: builder.query({
      query: (id) => `/geo/city/${id}/`,
      providesTags: ['Geo'],
    }),
    getGeoCountryInfoById: builder.query({
      query: (id) => `/geo/country/${id}/`,
      providesTags: ['Geo'],
    }),
    getGeoRegionInfoById: builder.query({
      query: (id) => `/geo/region/${id}/`,
      providesTags: ['Geo'],
    }),
    getSubregionInfoById: builder.query({
      query: (id) => `/geo/subregion/${id}/`,
      providesTags: ['Geo'],
    }),
    getEntitiesInfoById: builder.query({
      query: (id) => `/geo/entities/${id}`,
      providesTags: ['Geo'],
    }),
  }),
});

export const {
  useGetGeoNamesBySearchQuery,
  useGetGeoNameByGeonameIdAndLangQuery,
  useLazyGetGeoNameByGeonameIdAndLangQuery,
  useGetGeoCityInfoByIdQuery,
  useGetGeoCountryInfoByIdQuery,
  useLazyGetGeoCountryInfoByIdQuery,
  useGetGeoRegionInfoByIdQuery,
  useGetSubregionInfoByIdQuery,
  useGetEntitiesInfoByIdQuery,
} = apiGeoSlice;

export default apiGeoSlice;
